import React, { FunctionComponent } from 'react';
import { Grid, Modal } from 'semantic-ui-react';
import { pathOr } from 'ramda';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';
import { DefaultError } from 'scenes/Report/components/Query/Query.helpers';

const styles = {
  modalTrigger: {
    '&:hover': {
      color: '#683caf',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },

  description: {
    overflow: 'hidden !important',
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  name: string;
  error?: DefaultError;
};

const FailedReport: FunctionComponent<Props> = ({ classes, name, error }) => (
  <Grid.Column key={name} textAlign="left" width={16}>
    <Modal
      dimmer="blurring"
      trigger={<span className={classes.modalTrigger}>{name}</span>}
    >
      <Modal.Header>
        {pathOr('Something went wrong', [0, 'displayMessage'], error)}
      </Modal.Header>

      <Modal.Content image className={classes.description}>
        <Modal.Description>
          {pathOr(
            'Not enough data to display at this time',
            [0, 'message'],
            error,
          )}
        </Modal.Description>
      </Modal.Content>
    </Modal>
  </Grid.Column>
);

export default withStyles(styles)(FailedReport);
